var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import rotService from "@/core/services/rotService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Inspecao_Anomalia_StatusActions } from "@/store/enums/rotEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Inspecao_Anomalia_StatusModule = class Inspecao_Anomalia_StatusModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Inspecao_Anomalia_StatusActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            rotService.getFile("Inspecao_Anomalia_Status/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Inspecao_Anomalia_Status.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Inspecao_Anomalia_StatusActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            rotService.postFile("Inspecao_Anomalia_Status/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Inspecao_Anomalia_StatusActions.POST_INSPECAO_ANOMALIA_STATUS](data) {
        return new Promise(resolve => {
            rotService.post("Inspecao_Anomalia_Status/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Inspecao_Anomalia_StatusActions.PUT_INSPECAO_ANOMALIA_STATUS](data) {
        return new Promise(resolve => {
            rotService.put("Inspecao_Anomalia_Status/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Inspecao_Anomalia_StatusActions.DELETE_INSPECAO_ANOMALIA_STATUS](data) {
        return new Promise(resolve => {
            rotService.delete("Inspecao_Anomalia_Status/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Inspecao_Anomalia_StatusActions.DELETE_RANGE_INSPECAO_ANOMALIA_STATUS](data) {
        return new Promise(resolve => {
            rotService.delete("Inspecao_Anomalia_Status/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Inspecao_Anomalia_StatusActions.FILTER_INSPECAO_ANOMALIA_STATUS](data) {
        return new Promise(resolve => {
            rotService.post("Inspecao_Anomalia_Status/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Inspecao_Anomalia_StatusActions.GET_INSPECAO_ANOMALIA_STATUS]() {
        return new Promise(resolve => {
            rotService.get("Inspecao_Anomalia_Status/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Inspecao_Anomalia_StatusActions.GETWITHDISABLED_INSPECAO_ANOMALIA_STATUS]() {
        return new Promise(resolve => {
            rotService.get("Inspecao_Anomalia_Status/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Inspecao_Anomalia_StatusActions.GET_BY_ID_INSPECAO_ANOMALIA_STATUS](data) {
        return new Promise(resolve => {
            rotService.get("Inspecao_Anomalia_Status/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Anomalia_StatusModule.prototype, _k, null);
Inspecao_Anomalia_StatusModule = __decorate([
    Module
], Inspecao_Anomalia_StatusModule);
export default Inspecao_Anomalia_StatusModule;
//********** COMENTÁRIO GERADO EM: 18/06/2025 09:27:37 **********
//
//import rotService from "@/core/services/rotService";
//import JwtService from "@/core/services/JwtService";
//import { Mutations } from "@/store/enums/StoreEnums";
//import {Inspecao_Anomalia_StatusActions} from "@/store/enums/rotEnums";
//import {Module, Action, VuexModule} from "vuex-module-decorators";
//
//
//@Module
//export default class Inspecao_Anomalia_StatusModule extends VuexModule {
//    errors = {};
//    isAuthenticated = !!JwtService.getToken();
//    
//	@Action
//    [Inspecao_Anomalia_StatusActions.DOWNLOAD_PLANILHA]() {
//        return new Promise((resolve, reject) => {
//            rotService.getFile("Inspecao_Anomalia_Status/DownloadPlanilhaModelo")
//                .then((response) => {
//                    const blob = new Blob([response.data], {
//                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                    });
//
//                    const url = window.URL.createObjectURL(blob);
//                    const link = document.createElement('a');
//                    link.href = url;
//                    link.setAttribute('download', 'Planilha_Modelo_Inspecao_Anomalia_Status.xlsx');
//                    document.body.appendChild(link);
//                    link.click();
//                    document.body.removeChild(link);
//
//                    resolve(response);
//                })
//                .catch((error) => {
//                    if (error.response) {
//                        this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
//                        reject(error.response.data.errors);
//                    } else {
//                        reject("Erro ao baixar a planilha.");
//                    }
//                });
//        });
//    }
//
//	 @Action
//    [Inspecao_Anomalia_StatusActions.UPLOAD_PLANILHA](file: File) {
//        const formData = new FormData();
//        formData.append('file', file); // Adiciona o arquivo ao FormData
//
//        return new Promise((resolve, reject) => {
//            rotService.postFile("Inspecao_Anomalia_Status/ImportarPlanilha", formData)
//                .then(({ data }) => {
//                    resolve(data); // Sucesso
//                })
//                .catch((error) => {
//                    if (error.response) {
//                        this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
//                        reject(error.response.data.errors); // Rejeita com o erro
//                    } else {
//                        reject("Erro ao enviar a planilha.");
//                    }
//                });
//        });
//    }
//
//    @Action
//    [Inspecao_Anomalia_StatusActions.POST_INSPECAO_ANOMALIA_STATUS] (data) {
//        return new Promise(resolve => {
//			rotService.post("Inspecao_Anomalia_Status/Post", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//		});
//    }
//
//	@Action
//	[Inspecao_Anomalia_StatusActions.PUT_INSPECAO_ANOMALIA_STATUS] (data) {
//        return new Promise(resolve => {
//            rotService.put("Inspecao_Anomalia_Status/Put", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Anomalia_StatusActions.DELETE_INSPECAO_ANOMALIA_STATUS](data) {
//        return new Promise(resolve => {
//            rotService.delete("Inspecao_Anomalia_Status/Delete", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Anomalia_StatusActions.DELETE_RANGE_INSPECAO_ANOMALIA_STATUS](data) {
//        return new Promise(resolve => {
//            rotService.delete("Inspecao_Anomalia_Status/DeleteRange", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Anomalia_StatusActions.FILTER_INSPECAO_ANOMALIA_STATUS](data) {
//        return new Promise(resolve => {
//            rotService.post("Inspecao_Anomalia_Status/Filter", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Anomalia_StatusActions.GET_INSPECAO_ANOMALIA_STATUS]() {
//        return new Promise(resolve => {
//            rotService.get("Inspecao_Anomalia_Status/Get")
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//    [Inspecao_Anomalia_StatusActions.GETWITHDISABLED_INSPECAO_ANOMALIA_STATUS]() {
//        return new Promise(resolve => {
//            rotService.get("Inspecao_Anomalia_Status/GetWithDisabled")
//				  .then(({ data }) => {
//				resolve(data);
//			})
//                .catch (({ response }) => {
//				this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Anomalia_StatusActions.GET_BY_ID_INSPECAO_ANOMALIA_STATUS](data) {
//        return new Promise(resolve => {
//            rotService.get("Inspecao_Anomalia_Status/GetById", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//}
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=Inspecao_Anomalia_StatusModule.js.map